import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  *{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    font-family: "Inter", sans-serif;
  }
  body{
    font-size: 1rem;
    background: ${({ theme }) => theme.colors.backgroundColor};
  }
  button{
    cursor: pointer;
  }
  h1 {
    font-size: 2.5rem;
    font-weight: 600;
    margin-bottom: 24px;
  }
  h2 {
    font-size: 2rem;
    font-weight: 600;
  }
  h3 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 16px;
  }
`;
